(function () {
  new InstagramFeed({
    'username': 'yeahiworkout',
    'container': document.getElementById('instagram-feed'),
    'display_profile': false,
    'display_biography': false,
    'display_gallery': true,
    'callback': null,
    'styling': true,
    'items': 5,
    'items_per_row': 5,
    'margin': 0,
    // 'lazy_load': true,
    'on_error': console.error
  });
})();